export default {
  CN: {
    hello: "你好世界",
    Site_Home:"官网首页",
    //左侧菜单
    Overview: "概况",
    print: "打印",
    Home_scan: "扫描",
    wallet: "钱包",
    record: "消费",
    Message: "消息",
    WeChat: "微信客服",
    Phone: "电话客服",
    PersonalCenter: "个人中心",
    SignOut: "退出登录",
    //概览
    DataSurvey: "数据概况",
    ConsumptionRrend: "消费走势",
    Consumptionratio: "消费占比",
    Copy_page: "复印(页)",
    Print_page: "打印(页)",
    Scan_page: "扫描(页)",
    Home_Page: "印张",
    Home_Cost: "费用",
    Home_Copy: "复印",
    //扫描
    scandocument: "扫描文件",
    FileName: "文件名",
    Colour: "颜色",
    Size: "大小",
    Page: "页数",
    ScanDate: "时间",
    Operate: "操作",
    Preview: "预览",
    Delete: "删除",
    Download: "下载",
    BW: "黑白",
    Colour: "彩色",
    NoData: "暂无数据",
    //打印
    Printlist: "打印列表",
    FilName: "文件名",
    PrintSize: "大小",
    PrintPage: "页数",
    PrintDate: "提交时间",
    Mode: "提交方式",
    FileStatus: "文件状态",
    Operate: "操作",
    AddFiles: "添加文件",
    Print_file_upload:"上传",
    Print_file_drive:"驱动",
    DragAndDropFilesToThisAreaToUpload: "支持将文件拖拽至此区域进行上传！",
    PRINT_AddFiles: "继续添加",
    Upload: "开始上传",
    Waiting: "等待上传",
    Uploading: "上传中",
    Success: "上传完成",
    InConversion: "转换中",
    ConversionFailed: "转换失败",
    WaitingForPrinting: "等待打印",
    Page: "页",
    Preview: "预览",
    Delete: "删除",
    //钱包
    MyPurse: "我的钱包",
    AccountBalance: "账户余额(元)",
    AccountBalanceShare: "账户余额(共享)",
    AccountBalanceShare1: "账户余额(配额)",
    yuan: "元",
    Other: "其它金额",
    Pay: "去支付",
    Receiver: "收款方：云知印（重庆）信息技术有限公司",
    ScanCodeRecharge: "扫码充值",
    ApplicationQuota:"申请额度",
    ApplicationDescription:"申请说明",
    submit:"提交企业管理员审核",
    //消费
    ExpensesRecord: "消费记录",
    Time: "时间",
    JobDate: "作业时间",
    Type: "消费类型",
    Name: "作业名称",
    Size: "尺寸",
    Page: "页数",
    OriginalFileNumber:"原文件页数",
    PlanTotalPages:"计划出纸数",
    Colour: "色彩",
    OrderNumber: "订单号",
    Site: "站点",
    Device: "设备",
    OrderAmount: "订单金额",
    Refund: "退款",
    Deduction: "打印券抵扣",
    Expenses_details_EventOffer:"设备限免",
    PayMode: "支付方式",
    ActualPayment: "实际支付",
    ExpensesCopy: "复印消费",
    ExpensesPrint: "打印消费",
    ExpensesScan: "扫描消费",
    ExpensesUserRecharge: "用户充值",
    ExpensesPlatformRecharge: "平台充值",
    ExpensesEmployeeRecharge: "员工充值",
    ExpensesAbnormalRefund: "异常退款",
    ExpensesManualRefund: "人工退款",
    payModeWallet:"钱包",
    payModeWechat:"微信",
    payModeAliPay:"支付宝",
    payModeFree:"免费",
    payModeCorporateWallet:"企业钱包",
    ActualPaperOutput:"实际出纸数",
    //信息中心
    informationCenter: "信息中心",
    //个人中心
    PersonalInformation: "个人信息",
    AccountNumber: "账号",
    Nickname: "昵称",
    Identifier: "认证号",
    Birthday: "生日",
    Area: "地区",
    pleaseChoose: "请选择",
    Email: "邮箱",
    Save: "保存",
    Company: "所属企业",
    Department: "所属部门",
    Type: "消费模式",
    quota:"配额",
    shared:"共享",
    AvailableFeatures: "可用功能",
    ScanConfiguration: "扫描配置",
    ScanToEmail: "扫描至邮箱",
    PleaseInputTheEmailAddress: "请输入邮箱地址",
    ScanToLocalDirectory: "扫描至本地目录",
    DirectoryAddress: "目录地址",
    LoginAccount: "登录账号",
    LoginPassword: "登录密码",
    DomainServer: "域服务器",
    AccountSecurity: "账户安全",
    AccountPassword: "账户密码",
    NotSet: "未设置",
    SetPassword: "设置密码",
    ThirdPartyBinding: "第三方绑定",
    DingTalk: "钉钉",
    WeChat: "微信",
    Bind: "绑定",
    Unbind: "解除绑定",
    //登录注册等
    Mobileprintingismoreconvenient: "使用手机移动打印更方便",
    Downloadmobileapp: "下载手机APP",
    ScancodedownloadcloudZhiyiAPP: "扫码下载云知印APP",
    scantheloginTips: "打开云知印APP或小程序，扫码登录",
    Pleaseenterthephonenumber: "请输入手机号\\企业员工账号",
    Pleaseenterthephonenumber2: "请输入手机号",
    phonenumberError: "手机号码错误",
    SmsCode: "请输入验证码",
    SMSverificationcodeerror: "短信验证码错误",
    getverificationcode: "获取验证码",
    loginRegister: "登录注册",
    Accountpasswordlogin: "账号密码登录",
    AccountpasswordloginWechat: "微信扫码登录",
    OpenWeChatandscan: "打开微信扫一扫",
    Automaticallyregisterlogintopersonalmembershipaccount: "自动注册/登录个人会员账户",
    Enterpriseadministratorlogin: "企业管理员登录",
    wrongPassword: "密码错误",
    forget: "忘记密码?",
    loginpassword: "请输入登录密码",
    siteHome: "官网首页",
    login: "立即登录",
    SmsCodeLogin: "短信验证码登录/注册",
    Mobile_Corporateemployeeaccount: "手机 / 企业员工账号",
    PleaseenterthePassword: "请输入密码",
    RetrievePassword: "找回密码",
    Next: "下一步",
    PleaseXetAPassword: "请设置密码",
    PasswordComputer: "登录密码用于设备端与电脑端登录",
    AccordingMobileNumber: "根据（网络安全法），请绑定您的手机号",
    ImportantAccountSettings:
      "重要提示：企业用户请在密码登录界面，通过员工账号和密码登录后，在“账户设置”中绑定微信或钉钉",
    IncomeRecord:"收入记录",
    Recordingtime:"记录时间",
    Amount:"金额",
    IncomeType:"收入类型",
    KeepLogin:"保持登录",
    TabLogin:"登录",
    TabRegister:"验证码注册",
    Agreement1:"我已阅读并同意",
    Agreement2:"《隐私政策声明》",
    retrievePwdTips:"企业员工请联系管理员找回密码",
    Confirm:"确定"
  },
  EN: {
    hello: "hello world",
    Site_Home:"home",
    //左侧菜单
    Overview: "Home",
    print: "print",
    Home_scan: "scan",
    wallet: "wallet",
    record: "record",
    Message: "Message",
    WeChat: "WeChat",
    Phone: "Phone",
    PersonalCenter: "Personal center",
    SignOut: "Sign out",
    //概览
    DataSurvey: "Data survey",
    ConsumptionRrend: "Consumption trend",
    Consumptionratio: "Consumption ratio",
    Copy_page: "Copy(page)",
    Print_page: "Print(page)",
    Scan_page: "Scan(page)",
    Home_Page: "Page",
    Home_Cost: "Cost",
    Home_Copy: "Copy",
    //扫描
    scandocument: "scan document",
    FileName: "File name",
    Colour: "Colour",
    Size: "Size",
    Page: "Page",
    ScanDate: "Date",
    Operate: "Operate",
    Preview: "Preview",
    Delete: "Delete",
    Download: "Download",
    BW: "B/W",
    Colour: "Colour",
    NoData: "No data",
    //打印
    Printlist: "Print list",
    MyPurse: "My Purse",
    FilName: "File name",
    PrintSize: "Size",
    PrintPage: "Page",
    PrintDate: "Date",
    Mode: "Mode",
    FileStatus: "File status",
    Operate: "Operate",
    AddFiles: "Add files",
    Print_file_upload:"Upload",
    Print_file_drive:"Drive",
    DragAndDropFilesToThisAreaToUpload:
      "Drag and drop files to this area to upload!",
    PRINT_AddFiles: "Add files",
    Upload: "Upload",
    Waiting: "Waiting",
    Uploading: "Uploading",
    Success: "Success",
    InConversion: "In conversion",
    ConversionFailed: "Conversion failed",
    WaitingForPrinting: "Waiting for printing",
    Page: "Page",
    Preview: "Preview",
    Delete: "Delete",
    //钱包
    MyPurse: "MyPurse",
    AccountBalance: "Account balance (yuan)",
    AccountBalanceShare: "Account balance (shared)",
    AccountBalanceShare1: "Account balance (quota)",
    yuan: "yuan",
    Other: "Other",
    Pay: "Pay",
    Receiver:
      "Receiver: Yunzhiyin (Chongqing) Information Technology Co., Ltd.",
    ScanCodeRecharge: "Scan code recharge",
    ApplicationQuota:"Application quota",
    ApplicationDescription:"Application description",
    submit:"Submit review",
    //消费记录
    ExpensesRecord: "Expenses record",
    Time: "Time",
    JobDate: "Date",
    Type: "Type",
    Name: "Name",
    Size: "Size",
    Page: "Page",
    OriginalFileNumber:"Original file number",
    PlanTotalPages:"Planned Paper",
    Colour: "Colour",
    OrderNumber: "Order number",
    Site: "Site",
    Device: "Device",
    OrderAmount: "Order amount",
    Refund: "Refund",
    Deduction: "Deduction",
    Expenses_details_EventOffer:"Event offer",
    PayMode: "Pay Mode",
    ActualPayment: "Actual payment",
    ExpensesCopy: "Copy",
    ExpensesPrint: "Print",
    ExpensesScan: "Scan",
    ExpensesUserRecharge: "User recharge",
    ExpensesPlatformRecharge: "Platform recharge",
    ExpensesEmployeeRecharge: "Employee recharge",
    ExpensesAbnormalRefund: "Abnormal refund",
    ExpensesManualRefund: "Manual refund",
    payModeWallet:"wallet",
    payModeWechat:"Wechat",
    payModeAliPay:"Alipay",
    payModeFree:"Free",
    payModeCorporateWallet:"Corporate Wallet",
    ActualPaperOutput:"actual paper output",
    
    //信息中心
    informationCenter: "information Center",
    //个人中心
    PersonalInformation: "Personal information",
    AccountNumber: "Account number",
    Nickname: "Nickname",
    Identifier: "Identifier",
    Birthday: "Birthday",
    Area: "Area",
    pleaseChoose: "please choose",
    Email: "Email",
    Save: "Save",
    Company: "Company",
    Department: "Department",
    Type: "Type",
    quota:"quota",
    shared:"shared",
    AvailableFeatures: "Available features",
    ScanConfiguration: "Scan configuration",
    ScanToEmail: "Scan to email",
    PleaseInputTheEmailAddress: "Please input the email address",
    ScanToLocalDirectory: "Scan to local directory",
    DirectoryAddress: "Directory address",
    LoginAccount: "Login account",
    LoginPassword: "Login password",
    DomainServer: "Domain server",
    AccountSecurity: "Account security",
    AccountPassword: "Account password",
    NotSet: "Not set",
    SetPassword: "Set password",
    ThirdPartyBinding: "Third party binding",
    DingTalk: "Ding Talk",
    WeChat: "WeChat",
    Bind: "Bind",
    Unbind: "Unbind",
    //登录注册等
    Mobileprintingismoreconvenient: "Mobile printing is more convenient",
    Downloadmobileapp: "Download mobile app",
    ScancodedownloadcloudZhiyiAPP: "Scan code download Yun Zhi Yin APP",
    scantheloginTips: "Open the aidprint app or applet , scan the code to log in",
    Pleaseenterthephonenumber: "Mobile phone \\ employee number",
    Pleaseenterthephonenumber2: "Mobile phone number",
    phonenumberError: "Mobile number error",
    SmsCode: "Verification code",
    SMSverificationcodeerror: "SMS verification code error",
    getverificationcode: "Get code",
    loginRegister: "login/Register",
    Accountpasswordlogin: "Login with a password",
    AccountpasswordloginWechat: "WeChat QR code Login",
    OpenWeChatandscan: "Open WeChat and scan",
    Automaticallyregisterlogintopersonalmembershipaccount: "Automatically register/log in to personal membership account",
    Enterpriseadministratorlogin: "Enterprise administrator login",
    wrongPassword: "wrong password",
    forget: "Forgot password?",
    loginpassword: "login password",
    siteHome: "home",
    login: "login",
    SmsCodeLogin: "SMS verification code login",
    Mobile_Corporateemployeeaccount: "Mobile / Corporate employee account",
    PleaseentertheMobile_Corporateemployeeaccount:
      "Please enter the Mobile / Corporate employee account",
    PleaseenterthePassword: "Please enter the Password",
    RetrievePassword: "Retrieve password",
    Next: "Next",
    PasswordComputer: "Please set a password",
    PasswordComputer:
      "Password is used for login on the device and the computer",
    AccordingMobileNumber:
      "According to (Network Security Law), please bind your mobile number",
    ImportantAccountSettings:
      "Important: Enterprise users should log in to the password login interface, log in with their employee account and password, and bind WeChat or Pin in 'Account Settings'",
      IncomeRecord:"Income Record",
      Recordingtime:"Recording time",
      Amount:"Amount",
      IncomeType:"Income type",
      KeepLogin:"Keep signed in",
      TabLogin:"Sign in",
      TabRegister:"Register",
      Agreement1:"I agree",
      Agreement2:"with the privacy policy",
      retrievePwdTips:"Enterprise employees, please contact the administrator to retrieve the password",
      Confirm:"Confirm"
  }
};
